import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atelierSulphurpoolLight, atelierSulphurpoolDark } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import SecondaryButton from "./SecondaryButton";
import { CopyClipboard, LightDarkMode } from '../assets/images/utility';
import ClipboardCopyUtils from '../utils/ClipboardCopyUtils';
import Button from './Button';
export var CodeSnippetBackgroundStyle;
(function (CodeSnippetBackgroundStyle) {
    CodeSnippetBackgroundStyle[CodeSnippetBackgroundStyle["DARK"] = 0] = "DARK";
    CodeSnippetBackgroundStyle[CodeSnippetBackgroundStyle["LIGHT"] = 1] = "LIGHT";
})(CodeSnippetBackgroundStyle || (CodeSnippetBackgroundStyle = {}));
const CodeSnippet = (props) => {
    const [activeCodeSnippetTitle, setActiveCodeSnippetTitle] = useState("");
    const [codeSnippetBackgroundStyle, setCodeSnippetBackgroundStyle] = useState(CodeSnippetBackgroundStyle.LIGHT);
    useEffect(() => {
        if (props.codeSnippetBackgroundStyle !== undefined && !isNaN(props.codeSnippetBackgroundStyle)) {
            setCodeSnippetBackgroundStyle(props.codeSnippetBackgroundStyle);
        }
    }, [props.codeSnippetBackgroundStyle]);
    useEffect(() => {
        setActiveCodeSnippetTitle(props.snippets[0].title);
    }, [JSON.stringify(props.snippets)]);
    const onClickCopySectionButton = (snippetText) => {
        ClipboardCopyUtils.copyToClipboard(snippetText);
    };
    const onCodeSnippetBackgroundStyleToggle = () => {
        if (props.toggleCodeSnippetBackgroundStyle) {
            props.toggleCodeSnippetBackgroundStyle(codeSnippetBackgroundStyle);
        }
        else {
            setCodeSnippetBackgroundStyle(codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.LIGHT ? CodeSnippetBackgroundStyle.DARK : CodeSnippetBackgroundStyle.LIGHT);
        }
    };
    const getCodeSnippetBackgroundStyle = () => {
        return props.codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.LIGHT ? atelierSulphurpoolLight : atelierSulphurpoolDark;
    };
    const renderControls = () => {
        return props.snippets.map((snippet) => {
            return props.snippets.length > 1 ? React.createElement(CodeSnippetButton, { key: snippet.title, text: snippet.title, isActive: activeCodeSnippetTitle === snippet.title, onClick: () => setActiveCodeSnippetTitle(snippet.title) }) : null;
        });
    };
    const renderSnippets = () => {
        return props.snippets.map((snippet) => {
            if (activeCodeSnippetTitle !== snippet.title)
                return null;
            const lineHighlight = snippet.lineHighlight;
            return (React.createElement(CodeSnippetContainer, { key: snippet.title },
                React.createElement(CodeSnippetCopySectionButton, { text: '', imgAlt: "Copy", height: 17, width: 17, imgSrc: CopyClipboard, codeSnippetBackgroundStyle: codeSnippetBackgroundStyle, onClick: () => onClickCopySectionButton(snippet.code) }),
                React.createElement(CodeSnippetToggleStylesButton, { text: '', imgAlt: codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.LIGHT ? "Dark Mode" : "Light Mode", height: 17, width: 17, imgSrc: LightDarkMode, codeSnippetBackgroundStyle: codeSnippetBackgroundStyle, onClick: () => onCodeSnippetBackgroundStyleToggle() }),
                React.createElement(CodeSnippetSection, { key: snippet.title, language: snippet.language ? snippet.language : null, style: getCodeSnippetBackgroundStyle(), wrapLines: true, wrapLongLines: true, lineProps: lineNumber => {
                        const style = { fontWeight: 0 };
                        if (lineHighlight && lineHighlight.lineNumbers.includes(lineNumber)) {
                            style.fontWeight = 900;
                        }
                        return { style };
                    } }, snippet.code)));
        });
    };
    return React.createElement(CodeSnippetWrapper, null,
        renderControls(),
        renderSnippets());
};
const CodeSnippetWrapper = styled.div `
    margin: 0;
`;
const CodeSnippetButton = styled(SecondaryButton) `
    display: inline-block;
    margin-right: 10px;

    color: ${props => props.theme.colors.textBlue};
    color: ${props => props.isActive && props.theme.colors.white};
    background: ${props => props.isActive && props.theme.colors.textBlue};

    border: none;
    border-radius: 2px;

    :active {
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.textBlue};

        border: 1px solid ${props => props.theme.colors.textBlue};
    }

    :hover {
        border: none;
    }
`;
const CodeSnippetContainer = styled.div `
    position: relative;
`;
const CodeSnippetSection = styled(SyntaxHighlighter) `
    padding: 13px 20px !important;
    margin-top: 10px;

    border-radius: 4px;    
`;
const CodeSnippetCopySectionButton = styled(Button) `
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 0;
    -webkit-filter: ${props => props.codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.DARK ? 'invert(100%)' : 'none'};
    transition: opacity 250ms;
    opacity: 1;
    &:hover {
        opacity: .5;
        cursor: pointer;
    }
`;
const CodeSnippetToggleStylesButton = styled(Button) `
    position: absolute;
    top: 10px;
    right: 40px;
    padding: 0;
    -webkit-filter: ${props => props.codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.DARK ? 'invert(100%)' : 'none'};
    transition: opacity 250ms;
    opacity: 1;
    &:hover {
        opacity: .5;
        cursor: pointer;
    }
`;
export default CodeSnippet;
//# sourceMappingURL=CodeSnippet.js.map